import { format } from 'date-fns'
import {
  FinancialReport,
  ReportRepository,
} from '../repositories/ReportRepository'
import { useData } from './useData'

const reportRepository = new ReportRepository()

export function useOwnerReportDetails(
  ownerId: string,
  startDate: Date | null,
  endDate: Date | null
) {
  const { data: payoutData, isLoading: loading } = useData<FinancialReport>({
    repository: reportRepository,
    fetcher: (repo) =>
      (repo as ReportRepository).getOne({
        startDate: startDate ? format(startDate, 'yyyy-MM-dd') : '',
        endDate: endDate ? format(endDate, 'yyyy-MM-dd') : '',
        ownerId,
      }),
    queryKey: [
      'financialReport',
      ownerId,
      startDate ? format(startDate, 'yyyy-MM-dd') : '',
      endDate ? format(endDate, 'yyyy-MM-dd') : '',
    ],
    options: {
      enabled: !!ownerId && !!startDate && !!endDate,
    },
  })

  return {
    payoutData: payoutData as FinancialReport,
    loading,
  }
}
